import React, { useRef, useState, useEffect } from "react";
import {isAuthenticated}  from "../../../auth"
import { followResponse, getAllFollowup, getFollowup, getFollowupCount } from "../helper/api";
import { formatDateAndTime, formatDateTime, startLoader, stopLoader } from "../../../lib/utils";
// import config from "../../../config";
import client from "../../../clients";
import { getUsersList, getUsersListV2 } from "../../employees/helper/api";
import Flatpickr from "flatpickr";
import Toast from "../../../lib/toast";

const FollowUpHistory = (props={
  followup:null,
  close:()=>{},
  closeAndReload:()=>{}
}) => {

  const [currentElementId, setCurrentElementId] = useState("");
  const [userList,setUserList] = useState([]);
  const [currentDropdownIndex, setCurrentDropdownIndex] = useState(-1);
  const scheduleDateAndTimeRef = useRef(null);
  const [followupHistoryList,setFollowUpHistoryList] = useState([]);
  const [isLoaderStart,setLoaderStart] = useState(false);
  const [followUpHistory, setFollowUpHistory] = useState({});
  const {user,token} = isAuthenticated();
  const [dropDownType, setDropDownType] = useState("");
  const pageSize=20;
  var [pageNo,setPageNo] = useState(1);
  var [pageCount,setPageCount] = useState(1);
  var [total,setTotal] = useState(0);
  const [isButtonLock,setButtonLock] = useState(false);
  const [isApiCall,setApiCall] = useState(false);
  const [isFollowUpResponseFormOpen, setFollowUpResponseFormOpen] = useState(false);
  const [mainFollowUp, setMainFollowUp] = useState("");

  const HandleFollowupResponse = async event =>{
    event.preventDefault();
    await startLoader()
    try{
      setButtonLock(true)
      const payload = {};
      
      payload.call_remark=followUpHistory.call_remark;
      payload.call_response=followUpHistory.call_response;
      payload.convertibility = followUpHistory.convertibility;

      payload.date = followUpHistory.date;
      payload.dateString = followUpHistory.dateString;
      payload.assigned_to_id = followUpHistory.assigned_to_id;
      payload.to_do = followUpHistory.to_do;
      payload.not_interested_reason = followUpHistory.not_interested_reason;
      payload.followable_type = mainFollowUp?.followable_type


      let followupId = "";

      if(props.followup._id){
				payload.currentFollowUpId=props.followup._id;
			}

      if (followUpHistory?.call_response === "Successful Follow Up") {
        followupId = mainFollowUp?._id ?? "";
      } else {
        followupId = followupHistoryList.length > 0 ? followupHistoryList[0]?._id ?? "" : mainFollowUp?._id ?? "";
      }

      if(followupId !== ""){
        const response = await followResponse(user._id,token,followupId,payload);

        console.log(response);

        if(response.error){
          new Toast({
            type:"error",
            duration:3000,
            message:response.error
          })
        }else{
          new Toast({
            type:"success",
            duration:3000,
            message:"Followup response submitted"
          })

          setFollowUpResponseFormOpen(false);


          if(followUpHistory?.call_response === "Successful Follow Up"){            
            props.closeAndReload();
            props.close();
          }

          if(response.status == "done"){
            props.closeAndReload();
            toggleCurrentDropdownIndex(-1);
          }
          setApiCall(!isApiCall);
        }
      }else{
        new Toast({
          type:"error",
          duration:3000,
          message:"Selected Follow Up, Couldn't be Fetched !"
        })
      }
    }catch(error){
      console.log(error)
    }
    await stopLoader()
    setButtonLock(false)
  }

  const handleSelectDate = (id) =>{
     Flatpickr(id,{
          enableTime: true,
          noCalendar: false,
          dateFormat: "H:i",
          time_24hr: false,
          defaultDate: new Date(),
          onChange:(e)=>{
              setFollowUpHistory(oldstate=>{
                  oldstate['date'] = e[0]
                  oldstate['dateString'] = formatDateTime(e[0])
                  return ({...oldstate});
              })
          }
      }).open()
  }


  const GetAllUser = async (req,res)=>{
    try{
      const params = {
        noLimit:'noLimit',
        branchIDs:[props.followup.branchId],
        isAllUser:true,
        // roles:[5,6,7,10,2]
      };

      const response = await getUsersListV2(user._id,token,params);

      if(!response.error){
        setUserList(response)
      }

    }catch(error){

    }
  }

  const handleFollowupScroll = async event => {
    try {
      const { clientHeight, scrollTop, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && pageNo < pageCount && !isLoaderStart) {
        if (pageNo < pageCount) {
          pageNo = pageNo + 1;
          setPageNo({
            ...pageNo
          })
          setLoaderStart(true);
          await GetAllFollowups();
          setLoaderStart(false)
        }
      }
    } catch (error) {
      setLoaderStart(false)
    }
  }


  const GetFollowupParams = () =>{
    const params = {
      pageSize,
      pageNo,
      parentId: props.followup.parentId ? props.followup.parentId : props.followup._id
    }

    return params;
  }

  const GetAllFollowups = async (isReload) =>{
    try{
      const params = GetFollowupParams();
      const response = await getAllFollowup(user._id,token,params);
      if(!response.error) setFollowUpHistoryList(isReload?response:[...followupHistoryList,...response])
    }catch(error){

    }
  } 

  const GetFollowupsCount = async () =>{
    try{
      const params = GetFollowupParams();
      const response = await getFollowupCount(user._id,token,params);
      if(!response.error){
        pageNo = 1;
        setPageNo(pageNo)
        setTotal(response.COUNT);
        pageCount = Math.ceil(response.COUNT / pageSize);
        setPageCount(pageCount);
      }
    }catch(error){

    }
  } 

  const handleChange = key => event => {
    setFollowUpHistory(prev=>{
      prev[key] = event.target.value;
      return {...prev};
    });
  }

  const handleSelectDropdownItem = (type, value) => {
    try{
      setFollowUpHistory(prev=>{
        if(type == "convertibility-type"){
          prev.convertibility = value
        }else if(type == "call-response"){
          prev.call_response = value
        }else if(type == "assignee"){
          prev.assignedTo = value
          prev.assigned_to_id=value._id;
        }
        return {...prev}
      })
    }catch(error){
      
    }
    
    // if(type == "convertibility-type"){
    //   setFollowUpHistory((prev) => {
    //     const updatedFollowUps = [...prev.membershipInfo.followUpHistory.followUps];

    //     updatedFollowUps[index] = {
    //       ...updatedFollowUps[index],
    //       followUpResponse: {
    //         ...updatedFollowUps[index].followUpResponse,
    //         convertibility: value,
    //       },
    //     };

    //     return {
    //       ...prev,
    //       membershipInfo: {
    //         ...prev.membershipInfo,
    //         followUpHistory: {
    //           ...prev.membershipInfo.followUpHistory,
    //           followUps: updatedFollowUps,
    //         }
    //       }
    //     };

    //   });
    // }

    // if(type == "call-response"){
    //   setFollowUpHistory((prev) => {
    //     const updatedFollowUps = [...prev.membershipInfo.followUpHistory.followUps];

    //     updatedFollowUps[index] = {
    //       ...updatedFollowUps[index],
    //       followUpResponse: {
    //         ...updatedFollowUps[index].followUpResponse,
    //         callResponse: value,
    //       },
    //     };

    //     return {
    //       ...prev,
    //       membershipInfo: {
    //         ...prev.membershipInfo,
    //         followUpHistory: {
    //           ...prev.membershipInfo.followUpHistory,
    //           followUps: updatedFollowUps,
    //         }
    //       }
    //     };

    //   });
    // }

    // if(type == "assignee"){
    //   setFollowUpHistory((prev) => {
    //     const updatedFollowUps = [...prev.membershipInfo.followUpHistory.followUps];

    //     updatedFollowUps[index] = {
    //       ...updatedFollowUps[index],
    //       followUpResponse: {
    //         ...updatedFollowUps[index].followUpResponse,
    //         scheduleFollowUp: {
    //           ...updatedFollowUps[index].followUpResponse.scheduleFollowUp,
    //           assignee: value
    //         }
    //       },
    //     };

    //     return {
    //       ...prev,
    //       membershipInfo: {
    //         ...prev.membershipInfo,
    //         followUpHistory: {
    //           ...prev.membershipInfo.followUpHistory,
    //           followUps: updatedFollowUps,
    //         }
    //       }
    //     };

    //   });
    // }
  }

  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);

    if(id && `${id}`.includes("schedule-date-and-time")){
      handleSelectDate(scheduleDateAndTimeRef.current);
    }
    
    if(dropDownType != id){
      setDropDownType(id);
    }else{
      setDropDownType("");
    }
    
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
          element.focus();
          clearInterval(interval)
        }
      }, 0);
    }
  }

  const toggleCurrentDropdownIndex = (index) => {
    if(currentDropdownIndex != index){
      setCurrentDropdownIndex(index)
      setFollowUpHistory({})
    }else{
      setCurrentDropdownIndex(-1)
    }
  }

  const toggleFollowUpResponse = () => {
    setFollowUpResponseFormOpen(!isFollowUpResponseFormOpen)
  }

  // useEffect(() => {
  //   if (!scheduleDateAndTimeRef.current) return;

  //   const picker = flatpickr(scheduleDateAndTimeRef.current, {
  //     enableTime: true,
  //     disableMobile: true,
  //     dateFormat: "Y-m-d H:i",
  //     onChange: ([date]) => {
  //       if (date) {
  //         const istDate = date.toLocaleDateString('en-CA', {
  //           timeZone: 'Asia/Kolkata'
  //         });
  //         setFollowUpHistory((prev) => {
  //           const updatedFollowUps = [...prev.membershipInfo.followUpHistory.followUps];

  //           updatedFollowUps[index] = {
  //             ...updatedFollowUps[index],
  //             followUpResponse: {
  //               ...updatedFollowUps[index].followUpResponse,
  //               convertibility: istDate,
  //             },
  //           };

  //           return {
  //             ...prev,
  //             membershipInfo: {
  //               ...prev.membershipInfo,
  //               followUpHistory: {
  //                 ...prev.membershipInfo.followUpHistory,
  //                 followUps: updatedFollowUps,
  //               }
  //             }
  //           };

  //         });
  //       }
  //     }
  //   });

  //   return () => picker.destroy();
  // }, []);
  

  useEffect(async ()=>{
    //await startLoader()
    try{
      await GetAllUser();
    }catch(error){

    }
    //await stopLoader()
  },[])

  useEffect(async ()=>{
    try{
      // await startLoader();
      setLoaderStart(true)
      await GetFollowupsCount();
      await GetAllFollowups(true);
      // await stopLoader();
    }catch(error){
      console.error(error);
    }
    setLoaderStart(false)
    await stopLoader();
  },[isApiCall])

  useEffect(async()=>{
    if(props.followup.parentId){
      try{
        const response = await getFollowup(user._id, token, props.followup.parentId);
        console.log("parent followup",response);

        if(!response.error){
          setMainFollowUp(response);
        }
      }catch(err){
        console.log(err)
      }
    }else{
      setMainFollowUp(props.followup);
    }
    
  },[props.followup])

  

  useEffect(() => {
    if (userList.length > 0 && followUpHistory.call_response == "Follow Up Again") {
      const matchedUser = userList.find(
        data => data._id.toString() === user?._id?.toString()
      );

      if (matchedUser) {
        setFollowUpHistory(prev => ({
          ...prev,
          assignedTo: matchedUser,
          assigned_to_id: matchedUser._id
        }));
      }
    }else{
      setFollowUpHistory(prev => ({
        ...prev,
        assignedTo: "",
        assigned_to_id: ""
      }));
    }
  },[userList, followUpHistory.call_response])

  
  if(!props.followup){
    return <></>
  }

  return(
		<div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="global-modal-type-2 follow-up-response-modal flex-item" style={{width: window.innerWidth < 641 ? "100%" : "70%", height: window.innerWidth < 640 ? "100%" : "86%"}}>
        {
					window.innerWidth > 767 && (
            <div className="d-flex w-full space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item m-r-12' width="30" height="30" viewBox="0 0 27 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.29117 12.612L3.1676 13.6061C3.30145 13.7569 3.46443 13.8795 3.64671 13.9661C3.82899 14.0525 4.02687 14.1014 4.22847 14.1097C4.43008 14.1179 4.63126 14.0852 4.81998 14.0139C5.00871 13.9424 5.18107 13.8337 5.32678 13.6941L4.29117 12.612ZM8.57155 10.5821C8.84545 10.3038 8.99997 9.92989 9.00256 9.5393C9.00491 9.14895 8.85532 8.77295 8.5851 8.4913C8.31492 8.20942 7.9456 8.04425 7.55556 8.0306C7.16554 8.01695 6.78554 8.15578 6.49634 8.41813L8.57155 10.5821ZM2.65779 8.50613C2.52979 8.35013 2.37171 8.22189 2.193 8.12848C2.01427 8.0353 1.8186 7.97907 1.61764 7.96307C1.41669 7.94731 1.2146 7.97201 1.02345 8.03601C0.832296 8.10001 0.656009 8.20189 0.505125 8.33578C0.354241 8.46942 0.231865 8.63224 0.145286 8.81436C0.0587302 8.99648 0.00976016 9.19413 0.0013163 9.39554C-0.00712755 9.59719 0.0251199 9.79813 0.0961283 9.98683C0.16716 10.1758 0.275472 10.348 0.414642 10.4941L2.65779 8.50613ZM19.3913 5.51801C19.5252 5.66274 19.6858 5.77971 19.8648 5.86225C20.0436 5.94479 20.2369 5.99128 20.4338 5.9991C20.6304 6.00688 20.8268 5.97582 21.0117 5.90771C21.1965 5.83959 21.3659 5.73571 21.5105 5.60201C21.6554 5.46834 21.7723 5.30745 21.8546 5.12856C21.9372 4.94969 21.9838 4.75627 21.9915 4.55943C21.9993 4.36256 21.9682 4.16608 21.9003 3.98124C21.832 3.79637 21.7283 3.62674 21.5947 3.48201L19.3913 5.51801ZM13.6215 1.79814e-05C7.6519 1.79814e-05 2.79374 4.80601 2.79374 10.76H5.7926C5.7926 6.48601 9.28528 3.00001 13.6215 3.00001V1.79814e-05ZM2.79374 10.76V12.612H5.7926V10.76H2.79374ZM5.33078 13.6941L8.57155 10.5821L6.49634 8.41813L3.25556 11.528L5.33078 13.6941ZM5.41475 11.616L2.65779 8.50613L0.414642 10.4941L3.1676 13.6061L5.41475 11.616ZM21.5947 3.48201C20.5777 2.38157 19.3459 1.50395 17.973 0.904629C16.5999 0.305312 15.1195 -0.00271143 13.6215 1.79814e-05V3.00001C14.706 2.99736 15.7776 3.21997 16.7719 3.65373C17.7661 4.0875 18.6594 4.723 19.3953 5.52001L21.5947 3.48201ZM22.766 10.388L23.8859 9.39201C23.7518 9.24119 23.5886 9.11883 23.4063 9.03248C23.224 8.94613 23.0259 8.89742 22.8244 8.88942C22.6228 8.88142 22.4217 8.91413 22.2331 8.98566C22.0444 9.05742 21.872 9.16636 21.7267 9.30613L22.766 10.388ZM18.4898 12.416C18.2028 12.6918 18.0373 13.0704 18.0295 13.4682C18.0215 13.8664 18.172 14.2511 18.4477 14.5381C18.7236 14.8249 19.1018 14.9906 19.4998 14.9986C19.8975 15.0064 20.282 14.8558 20.569 14.58L18.4898 12.416ZM24.4075 14.496C24.675 14.7809 25.0431 14.9501 25.4335 14.9678C25.8239 14.9852 26.2057 14.8497 26.4976 14.5897C26.7895 14.3297 26.9685 13.9661 26.9962 13.5762C27.024 13.1861 26.8986 12.8007 26.6467 12.5021L24.4075 14.496ZM7.62791 17.5101C7.35429 17.2266 6.9802 17.0624 6.58647 17.0525C6.19273 17.0428 5.81097 17.1885 5.52369 17.4581C5.23641 17.7275 5.06669 18.0993 5.05117 18.4929C5.03564 18.8866 5.17557 19.2706 5.44074 19.5621L7.62791 17.5101ZM13.4016 23C19.3854 23 24.2655 18.2 24.2655 12.24H21.2669C21.2669 16.5101 17.7621 20 13.4016 20V23ZM24.2655 12.24V10.388H21.2669V12.24H24.2655ZM21.7267 9.30613L18.4898 12.416L20.569 14.58L23.8038 11.4701L21.7267 9.30613ZM21.6465 11.3861L24.4054 14.4941L26.6467 12.5021L23.8859 9.39201L21.6465 11.3861ZM5.43874 19.56C6.45981 20.6478 7.69325 21.5139 9.06254 22.1054C10.4319 22.6967 11.9083 23.0005 13.3997 22.9981V19.9981C11.1145 19.9981 9.06136 19.0381 7.62591 17.508L5.43874 19.56Z" fill="#ffffff"/>
                </svg>
                <p className="flex-item fs-16 font-weight-700 color-white">Follow Up History</p>
              </div>
              <div onClick={()=>props.close && props.close()} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div className='w-full' style={{height: "100%"}}>
          <div className="d-flex-wrap p-t-12 p-l-12 p-r-12 p-b-12" style={{borderBottom:"1px solid #90bcd7", background:"#eaf8ff"}}>
            <div className="d-flex m-r-20">
              
              {
                mainFollowUp?.user?.[0]?.profileID ?(
                  <img className="flex-item fh-member-profile m-r-12" src={`${client.config.API_URL}/image/file/${mainFollowUp.user[0].profileID}/auto/auto/70`} />
                ):(
                  <div className="tr-profile-image fh-member-profile d-flex flex-item m-r-12">
                    <p className='flex-item margin-auto' style={{fontSize:20}}>{`${mainFollowUp?.userInfo?.full_name}`.trim()[0]}</p>
                  </div>
                )
              }

              <div className="flex-item m-t-4">
                <p className="flex-item fs-16 font-weight-700" style={{lineHeight:"18px"}}>{mainFollowUp?.userInfo?.full_name}</p>
                <p className="flex-item m-t-2">+91 {mainFollowUp?.userInfo?.phone}</p>
                {/* {(props.followup.memberships && props.followup.memberships.length && props.followup.memberships[0].membershipDisplayNumber) && <p className="flex-item fs-14 color-dark-blue font-weight-700 m-t-6" style={{lineHeight:"14px"}}>
                 {`Resolution For Membership ID ${props.followup.memberships[0].membershipDisplayNumber}`}
                </p>} */}
              </div>
            </div>
            <div className="d-flex-wrap" style={{width: window.innerWidth < 641 && "100%", marginTop: window.innerWidth < 641 ? "20px" : "7px"}}>
              <div className="flex-item p-r-20 m-r-20" style={{borderRight:"1px solid #9fb2be", marginBottom:window.innerWidth < 641 && "20px",  borderLeft: window.innerWidth > 640 && "1px solid #9fb2be", paddingLeft: window.innerWidth > 640 && "20px"}}>
                <p className="flex-item font-weight-700" style={{lineHeight:"14px"}}>Date of Birth</p>
                <p className="flex-item font-weight-700 color-dark-blue m-t-6" style={{lineHeight:"14px"}}>{mainFollowUp?.user?.[0]?.dateofbirthString ? mainFollowUp.user[0].dateofbirthString:'---'}</p>
              </div>
              <div className="flex-item p-r-20 m-r-20" style={{borderRight:"1px solid #9fb2be", marginBottom:window.innerWidth < 641 && "20px"}}>
                <p className="flex-item font-weight-700" style={{lineHeight:"14px"}}>Anniversary Date</p>
                <p className="flex-item font-weight-700 color-dark-blue m-t-6" style={{lineHeight:"14px"}}>{mainFollowUp?.user?.[0]?.anniversaryDateString ? mainFollowUp.user[0].anniversaryDateString : '---' }</p>
              </div>
              <div className="flex-item p-r-20 m-r-20">
                <p className="flex-item font-weight-700" style={{lineHeight:"14px"}}>Email</p>
                <p className="flex-item font-weight-700 color-dark-blue m-t-6" style={{lineHeight:"14px"}}>{mainFollowUp.userInfo?.email?mainFollowUp.userInfo.email:'---'}</p>
              </div>
            </div>
          </div>
          <div style={{maxHeight:'82%',overflowY:'auto', padding:"12px 12px 140px 12px"}} onScroll={handleFollowupScroll}>

            <div className="w-full m-b-16 p-b-16" style={{borderBottom: "2px solid #5d883c"}}>
              <p className="font-weight-700 m-b-12 fs-15 color-red">Resolution for Follow Up ID - {mainFollowUp?.followupDisplayNumber}</p>
              
              <div className="w-full d-flex-wrap p-b-10 m-b-10" style={{borderBottom:"1px dashed #e0e0e0"}}>
              <div className="w-full m-b-12" style={{alignSelf:"flex-start", width: window.innerWidth < 641 ? "100%": "46%"}}>
                <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex" : ""} m-b-8`}>
                  <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Comment</p>
                  <p className="flex-item color-grey-01 fs-14 font-weight-700 p-r-8" style={{width: window.innerWidth < 641 ? "56%" : "80%"}}>{mainFollowUp?.to_do ? mainFollowUp?.to_do : "--"}</p>
                </div>
                  <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex" : ""}`}>
                       <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Status</p>
                         <p className="flex-item color-grey-01 fs-14 font-weight-700 p-r-8" style={{width: window.innerWidth < 641 ? "56%" : "80%", textTransform:"capitalize"}}>{mainFollowUp?.status}</p>
                   </div>
               </div>
                <div className="w-full m-b-12" style={{alignSelf:"flex-start", width: window.innerWidth < 641 ? "100%": "24%"}}>
                     <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex" : ""} m-b-8`}>
                           <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Follow Up Schedule</p>
                            <p className="flex-item color-grey-01 fs-14 font-weight-700" style={{width: window.innerWidth < 641 ? "56%" : ""}} >{mainFollowUp?.date ? formatDateAndTime(new Date(mainFollowUp?.date)) : "--"}</p>
                     </div>
                <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex" : ""}`}>
                     <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Type</p>
                       <p className="flex-item color-grey-01 fs-14 font-weight-700" style={{width: window.innerWidth < 641 ? "56%" : ""}}>{mainFollowUp?.followable_type ? mainFollowUp.followable_type : "--"}</p>
                 </div>
                 </div>
               <div className="w-full m-b-12" style={{alignSelf:"flex-start", width: window.innerWidth < 641 ? "100%": "16%"}}>
                <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex" : ""} m-b-8`}>
                  <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Schedule Type</p>
                 <p className="flex-item color-grey-01 fs-14 font-weight-700 p-r-8" style={{width: window.innerWidth < 641 ? "56%" : "80%"}}>{mainFollowUp?.scheduled_type}</p>
                </div>
                {
                    mainFollowUp?.followable_type == "Membership Renewal" && (
                     <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex" : ""}`}>
                     <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Membership Type</p>
                     <p className="flex-item color-grey-01 fs-14 font-weight-700 p-r-8" style={{width: window.innerWidth < 641 ? "56%" : "80%"}}>{mainFollowUp?.membership_plan_type ? mainFollowUp.membership_plan_type : "--"}</p>
                    </div>
                      )
                    }
                    </div>
                
              </div>
              
              <div className="d-flex-wrap">
                <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-12" : "m-r-40"} `} style={{width: window.innerWidth < 641 ? "100%": "46%", alignSelf: window.innerWidth > 641 && "flex-start" }}>           
                  <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Creation Date</p>
                  <p className="flex-item color-grey-01 fs-14 font-weight-700" style={{width: window.innerWidth < 641 ? "56%" : "", whiteSpace: window.innerWidth > 641 && "nowrap"}}>{formatDateAndTime(mainFollowUp.createdAt)}</p>
                </div>
                <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-12" : "m-r-40"} `} style={{width: window.innerWidth < 641 ? "100%": "", alignSelf: window.innerWidth > 641 && "flex-start"}}>           
                  <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Followed-Up By</p>
                  <p className="flex-item color-grey-01 fs-14 font-weight-700" style={{width: window.innerWidth < 641 ? "56%" : "", whiteSpace: window.innerWidth > 641 && "nowrap"}}>{(mainFollowUp.assignedTo && mainFollowUp.assignedTo.length)?mainFollowUp.assignedTo[0].name:"-"}</p>
                </div>
                <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex" : "flex-item"} `} style={{width: window.innerWidth < 641 ? "100%": "", alignSelf: window.innerWidth > 641 && "flex-start"}}>
                  <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Assigned Trainer</p>
                  <p className="flex-item color-grey-01 fs-14 font-weight-700" style={{width: window.innerWidth < 641 ? "56%" : "", whiteSpace: window.innerWidth > 641 && "nowrap"}}>{mainFollowUp?.createdByUser?.[0]?.name ? mainFollowUp.createdByUser[0].name : mainFollowUp.creation_type == "System generated" ? "System Generated" : "--"}</p>
                </div>
              </div>
              {
                (mainFollowUp?.marked_done == true || mainFollowUp?.status == "done") && (
                  <div className="m-t-16 follow-up-response-container" style={{background:"#f0fff9"}}>
                    <div className="d-flex-wrap">
                      <div className="flex-item" style={{marginRight:"6%", alignSelf:"flex-start"}}>
                        <p className="flex-item fs-12 color-grey-03">Remark</p>
                        <p className="flex-item font-weight-700">{mainFollowUp?.call_remark ? mainFollowUp.call_remark : "--"}</p>
                      </div>
                      <div className="flex-item" style={{width:"50%", alignSelf:"flex-start"}}>
                        <p className="flex-item fs-12 color-grey-03">Call Response</p>
                        <p className="flex-item font-weight-700">{mainFollowUp?.call_response ? mainFollowUp?.call_response : "--"}</p>
                      </div>
                    </div>
                  </div> 
                )
              }
            </div>

            <div className="flex-item d-flex" style={{alignSelf:"flex-start"}}>
              {
                props.followup.status != "done" && (
                  <div onClick={()=>toggleFollowUpResponse()} className="global-button-container space-between d-flex flex-item" style={{borderRadius:"20px", height:"40px", background: isFollowUpResponseFormOpen ? "var(--darkBlue)" : "#ffffff", boxShadow:"0px 0px 8px rgba(0,0,0,0.25)", border:"1px solid var(--darkBlue)"}}>
                    <p className="flex-item" style={{color: isFollowUpResponseFormOpen ? "#ffffff" : "", marginLeft:"0"}}>Follow Up Response</p>
                    <svg className="flex-item m-l-12 svg-stroke" style={{transform: isFollowUpResponseFormOpen ? "rotate(180deg)" : "", transition:"180ms"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L7 7L13 1" stroke={isFollowUpResponseFormOpen ? "#ffffff" : "#4d4d4d"} stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </div>
                )
              }
            </div>
            
            {
              isFollowUpResponseFormOpen && (
                <div className="m-t-12 follow-up-response-container" style={{border:"1px dashed #9a9a9a", background:"#e0e0e0"}}>
                  <p className="fs-14 font-weight-700 m-b-8">Follow Up Response</p>
                  <div className="d-flex-wrap space-between">
                    <div onClick={toggleInputFields('convertibility-type')} className={`${currentElementId == 'convertibility-type' || followUpHistory.convertibility ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'convertibility-type' || followUpHistory.convertibility ? "1px solid var(--darkBlue)" : "", width: window.innerWidth < 641 ? "100%" : "20%" }}>
                      <div className='d-flex w-full space-between'>
                        <div className='flex-item'>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'convertibility-type' || followUpHistory.convertibility ? "10px" : "", color: currentElementId == 'convertibility-type' || followUpHistory.convertibility ? "var(--darkBlue)" : "", transition: "180ms" }}>Convertibility <span className='color-red'>*</span></p>
                          </div>
                          <input style={{textTransform:'capitalize'}} readOnly value={followUpHistory.convertibility} type="text" placeholder="Select" className={`${currentElementId == 'convertibility-type' || followUpHistory.convertibility ? "active-input-field" : "inactive-input-field"}`} />
                        </div>
                        <div className='input-field-arrow-dropdown' style={{ transform: currentElementId == 'convertibility-type' ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                          <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                          </svg>
                        </div>
                        {
                          dropDownType == 'convertibility-type' && (
                            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                              <div onClick={()=>handleSelectDropdownItem("convertibility-type", "Hot")} className="global-input-field-arrow-dropdown-item">
                                <p className="flex-item">Hot</p>
                              </div>
                              <div onClick={()=>handleSelectDropdownItem("convertibility-type", "Warm")} className="global-input-field-arrow-dropdown-item">
                                <p className="flex-item">Warm</p>
                              </div>
                              <div onClick={()=>handleSelectDropdownItem("convertibility-type", "Cold")} className="global-input-field-arrow-dropdown-item">
                                <p className="flex-item">Cold</p>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </div>
                    <div onClick={toggleInputFields('call-response')} className={`${currentElementId == 'call-response' || followUpHistory.call_response ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'call-response' || followUpHistory.call_response ? "1px solid var(--darkBlue)" : "", width: window.innerWidth < 641 ? "100%" : "20%" }}>
                      <div className='d-flex w-full space-between'>
                        <div className='flex-item'>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'call-response' || followUpHistory.call_response ? "10px" : "", color: currentElementId == 'call-response' || followUpHistory.call_response ? "var(--darkBlue)" : "", transition: "180ms" }}>Call Response <span className='color-red'>*</span></p>
                          </div>
                          <input readOnly value={followUpHistory.call_response} type="text" placeholder="Select" className={`${currentElementId == 'call-response' || followUpHistory.call_response ? "active-input-field" : "inactive-input-field"}`} />
                        </div>
                        <div className='input-field-arrow-dropdown' style={{ transform: currentElementId == 'call-response' ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                          <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                          </svg>
                        </div>
                        {
                          dropDownType == 'call-response' && (
                            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                              <div onClick={()=>handleSelectDropdownItem("call-response", "Follow Up Again")} className="global-input-field-arrow-dropdown-item">
                                <p className="flex-item">Follow Up Again</p>
                              </div>
                              <div onClick={()=>handleSelectDropdownItem("call-response", "Successful Follow Up")} className="global-input-field-arrow-dropdown-item">
                                <p className="flex-item">Successful Follow Up</p>
                              </div>
                              <div onClick={()=>handleSelectDropdownItem("call-response", "Not Interested")} className="global-input-field-arrow-dropdown-item">
                                <p className="flex-item">Not Interested</p>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </div>
                    <div onClick={toggleInputFields('remark')} className={`${(currentElementId == 'remark' || followUpHistory.call_remark) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'remark' || followUpHistory.call_remark) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth < 641 ? "100%" : "58%"}}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'remark' || followUpHistory.call_remark) ? "10px" : "14px", color: (currentElementId == 'remark' || followUpHistory.call_remark) ? "var(--darkBlue)" : "", transition: "180ms" }}>Remark <span className="color-red">*</span></p>
                      </div>
                      <input onChange={handleChange('call_remark')} value={followUpHistory.call_remark} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'remark' || followUpHistory.call_remark) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Call Remark' />
                    </div>
                  </div>
                  {
                    followUpHistory.call_response == "Follow Up Again" && (
                      <div className="w-full">
                        <p className="fs-12 color-dark-blue font-weight-700 m-b-8">Schedule Follow Up</p>
                        <div className="d-flex-wrap space-between">
                          <div onClick={toggleInputFields('schedule-date-and-time')} className={`${(currentElementId == 'schedule-date-and-time' || followUpHistory.date) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'schedule-date-and-time' || followUpHistory.date) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth < 641 ? "100%" : "20%"}}>
                            <div className="flex-item d-flex">
                              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'schedule-date-and-time' || followUpHistory.date) ? "10px" : "14px", color: (currentElementId == 'schedule-date-and-time' || followUpHistory.date) ? "var(--darkBlue)" : "", transition: "180ms" }}>Date & Time <span className='color-red'>*</span></p>
                            </div>
                            <input ref={scheduleDateAndTimeRef} readOnly value={followUpHistory.date ? new Date(followUpHistory.date).toLocaleString() : ""} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'schedule-date-and-time' || followUpHistory.date) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD  HH:MM' />
                          </div>
                          <div onClick={toggleInputFields('assignee')} className={`${currentElementId == 'assignee' || followUpHistory.assignedTo ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'assignee' || followUpHistory.assignedTo ? "1px solid var(--darkBlue)" : "", width: window.innerWidth < 641 ? "100%" : "20%" }}>
                            <div className='d-flex w-full space-between'>
                              <div className='flex-item'>
                                <div className="flex-item d-flex">
                                  <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'assignee' || followUpHistory.assignedTo ? "10px" : "", color: currentElementId == 'assignee' || followUpHistory.assignedTo ? "var(--darkBlue)" : "", transition: "180ms" }}>Assignee <span className='color-red'>*</span></p>
                                </div>
                                <input readOnly value={followUpHistory.assignedTo && followUpHistory.assignedTo.name} type="text" placeholder="Select" className={`${currentElementId == 'assignee' || followUpHistory.assignedTo ? "active-input-field" : "inactive-input-field"}`} />
                              </div>
                              <div className='input-field-arrow-dropdown' style={{ transform: currentElementId == 'assignee' ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                                <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                </svg>
                              </div>
                              {
                                dropDownType == 'assignee' && (
                                  <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                  {
                                    userList.map(data=>{
                                      return(
                                        <div onClick={()=>handleSelectDropdownItem("assignee", data)} className="global-input-field-arrow-dropdown-item">
                                      <p className="flex-item">{data.name}</p>
                                    </div>
                                      )
                                    })
                                  }
                                  </div>
                                )
                              }
                            </div>
                          </div>
                          <div onClick={toggleInputFields('to-do')} className={`${(currentElementId == 'to-do' || followUpHistory.to_do) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'to-do' || followUpHistory.to_do) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth < 641 ? "100%" : "58%"}}>
                            <div className="flex-item d-flex">
                              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'to-do' || followUpHistory.to_do) ? "10px" : "14px", color: (currentElementId == 'to-do' || followUpHistory.to_do) ? "var(--darkBlue)" : "", transition: "180ms" }}>Comment</p>
                            </div>
                            <input onChange={handleChange('to_do')} value={followUpHistory.to_do} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'to-do' || followUpHistory.to_do) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Your Details' />
                          </div>
                        </div>
                      </div>
                    )
                  }

                  {
                    followUpHistory.call_response == 'Not Interested' && (
                      <div className="w-full m-b-20">
                        <p className="fs-12 color-dark-blue font-weight-700 m-b-8">Why Nikhil Deshpande is not interested ?</p> 
                        <div onClick={toggleInputFields('not-interested')} className={`${(currentElementId == 'not-interested' || followUpHistory.not_interested_reason) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'not-interested' || followUpHistory.not_interested_reason) ? "1px solid var(--darkBlue)" : "", width: "100%"}}>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'not-interested' || followUpHistory.not_interested_reason) ? "10px" : "14px", color: (currentElementId == 'not-interested' || followUpHistory.not_interested_reason) ? "var(--darkBlue)" : "", transition: "180ms" }}>Reason</p>
                          </div>
                          <input onChange={handleChange('not_interested_reason')} value={followUpHistory.not_interested_reason} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'not-interested' || followUpHistory.not_interested_reason) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Reason' />
                        </div>
                      </div>
                    )
                  }

                  <div className="flex-item d-flex m-t-10">
                    <div onClick={()=>toggleCurrentDropdownIndex()} className={`global-button-container d-flex flex-item m-r-12`} style={{borderRadius:"20px", border:"1px solid", height:"40px"}}>
                      <p className="flex-item color-black">Cancel</p>
                    </div>
                    <div onClick={isButtonLock?null:HandleFollowupResponse} className={`global-button-container button-red d-flex flex-item m-r-12`} style={{borderRadius:"20px", height:"40px", background:isButtonLock?"#6d6d6d":"#E33A34",pointerEvents:isButtonLock?'none':'auto'}}>
                      <p className="flex-item" style={{color:"#ffffff"}}>Submit Response</p>
                    </div>
                  </div>
                </div>
              )
            }

            <div className="w-full" style={{background:followupHistoryList.length > 0 && "#ffffff",  borderRadius:"12px", padding:"12px", boxShadow: followupHistoryList.length > 0 && "0px 0px 4px rgba(0,0,0,0.25)", marginTop: props.followup.status != "done" && "20px"}}>
              {
                followupHistoryList.map((data,index) => {
                  return(
                    <div className="w-full" style={{borderBottom: followupHistoryList.length != index + 1 && "1px solid #e0e0e0", padding: data.followupDisplayNumber == props.followup?.followupDisplayNumber && "12px", borderRadius: data.followupDisplayNumber == props.followup?.followupDisplayNumber && "12px", background: data.followupDisplayNumber == props.followup?.followupDisplayNumber ? "#e3f0e0" : "", marginBottom: followupHistoryList.length != index + 1 && "16px", paddingBottom: data.followupDisplayNumber == props.followup?.followupDisplayNumber ? "12px" : followupHistoryList.length != index + 1 && "12px"}}>
                      <div className="d-flex w-full">
                        <p className="font-weight-700 m-b-12 fs-15 color-dark-blue flex-item">Follow Up ID - <span className="color-blue">{data.followupDisplayNumber}</span> <span className="flex-item m-l-8 fs-15 color-red font-weight-700">{data.followupDisplayNumber == props.followup?.followupDisplayNumber && " -:- Currently Viewing"}</span></p>
                      </div>
                      <div className="w-full d-flex-wrap">

                        <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-12" : ""} `} style={{width: window.innerWidth < 641 ? "100%": "24%" }}>           
                          <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Creation Date</p>
                          <p className="flex-item color-grey-01 fs-14 font-weight-700" style={{width: window.innerWidth < 641 ? "56%" : "", whiteSpace: window.innerWidth > 641 && "nowrap"}}>{formatDateAndTime(new Date(data.createdAt))}</p>
                        </div>

                        <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-12" : "flex-item"} `} style={{width: window.innerWidth < 641 ? "100%": "24%"}}>
                          <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Follow Up Schedule</p>
                          <p className="flex-item color-grey-01 fs-14 font-weight-700" style={{width: window.innerWidth < 641 ? "56%" : ""}} >{formatDateAndTime(new Date(data.date))}</p>
                        </div>

                        {/* <div style={{width:"16%"}}>           
                          <p>Schedule Type</p>
                          <p className="flex-item color-grey-01 fs-14 font-weight-700 p-r-8" style={{width:"80%"}}>{data.scheduled_type}</p>
                        </div> */}
                       
                        {/* <div className="flex-item" style={{width:"10%"}}>
                          <p>Status</p>
                          <p className="flex-item color-grey-01 fs-14 font-weight-700 p-r-8" style={{width:"80%", textTransform:"capitalize"}}>{data.status}</p>
                        </div> */}
                        
                        {/* {
                            data.status == "done" && (
                              <svg className="margin-auto flex-item" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="10" fill="#5D883C"/>
                                <path d="M4.5 10.5L8 14.5L15 7" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                              </svg>
                            ) 
                          }
                          {
                            data.status == "missed" && (
                              <svg className="margin-auto flex-item" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="10" fill="#E33A34"/>
                                <path d="M6.20898 14.0833L13.7923 6.5M13.7923 14.0833L6.20898 6.5" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            ) 
                          }

                          {
                            data.status == "pending" && (
                              <svg className="flex-item margin-auto" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="10" fill="#EF9610"/>
                                <g clip-path="url(#clip0_0_1)">
                                <path d="M10 6.0625C10 5.94647 9.9539 5.83518 9.87186 5.75314C9.78982 5.6711 9.67853 5.625 9.5625 5.625C9.44647 5.625 9.33518 5.6711 9.25314 5.75314C9.1711 5.83518 9.125 5.94647 9.125 6.0625V10.875C9.12503 10.9521 9.14543 11.0279 9.18416 11.0945C9.22288 11.1612 9.27854 11.2165 9.3455 11.2548L12.408 13.0048C12.5085 13.0591 12.6262 13.072 12.7361 13.0405C12.8459 13.0092 12.9392 12.9361 12.9958 12.8369C13.0525 12.7377 13.0682 12.6203 13.0394 12.5098C13.0107 12.3992 12.9398 12.3042 12.842 12.2452L10 10.6213V6.0625Z" fill="white"/>
                                <path d="M10 17C11.8565 17 13.637 16.2625 14.9498 14.9498C16.2625 13.637 17 11.8565 17 10C17 8.14349 16.2625 6.36301 14.9498 5.05026C13.637 3.7375 11.8565 3 10 3C8.14349 3 6.36301 3.7375 5.05026 5.05026C3.7375 6.36301 3 8.14349 3 10C3 11.8565 3.7375 13.637 5.05026 14.9498C6.36301 16.2625 8.14349 17 10 17ZM16.125 10C16.125 11.6245 15.4797 13.1824 14.331 14.331C13.1824 15.4797 11.6245 16.125 10 16.125C8.37554 16.125 6.81763 15.4797 5.66897 14.331C4.52031 13.1824 3.875 11.6245 3.875 10C3.875 8.37554 4.52031 6.81763 5.66897 5.66897C6.81763 4.52031 8.37554 3.875 10 3.875C11.6245 3.875 13.1824 4.52031 14.331 5.66897C15.4797 6.81763 16.125 8.37554 16.125 10Z" fill="white"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_0_1">
                                <rect width="14" height="14" fill="white" transform="translate(3 3)"/>
                                </clipPath>
                                </defs>
                              </svg>            
                            )
                          } */}

                        <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-12" : ""} `} style={{width: window.innerWidth < 641 ? "100%" : "16%"}}>
                        <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Type</p>
                         <p className="flex-item color-grey-01 fs-14 font-weight-700" style={{width: window.innerWidth < 641 ? "56%" : "80%" }}>{mainFollowUp?.followable_type}</p>
                        </div>

                           {
                             mainFollowUp?.followable_type == "Membership Renewal" && (
                               <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-12" : ""} `} style={{width: window.innerWidth < 641 ? "100%" : "16%"}}>
                                   <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Membership Type</p>
                                   <p className="flex-item color-grey-01 fs-14 font-weight-700" style={{width: window.innerWidth < 641 ? "56%" : "80%" }}>{data.membership_plan_type ? data.membership_plan_type : "--"}</p>
                                  </div>
                                )
                                }

{/* <div style={{width:"20%"}}>           
  <p>Type</p>
  <p className="flex-item color-grey-01 fs-14 font-weight-700 " style={{width:"80%"}}>{mainFollowUp?.followable_type}</p>
</div> */}

                                 <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex" : ""} `} style={{width: window.innerWidth < 641 ? "100%": "28%"}}>
                                  <p style={{width: window.innerWidth < 641 ? "40%" : ""}}>Comment</p>
                                     <p className="flex-item color-grey-01 fs-14 font-weight-700" style={{width: window.innerWidth < 641 ? "56%" : "80%", paddingRight: window.innerWidth > 640 && "8px"}}>{data.to_do ? data.to_do : "--"}</p>
                                      </div>


                        <div className="flex-item">
                          {/* {
                            (data.status != "done" && data.rescheduled_followup.length ==0) && (
                              <div onClick={()=>toggleCurrentDropdownIndex(index)} className="global-button-container space-between w-full d-flex flex-item" style={{borderRadius:"20px", height:"40px", background: currentDropdownIndex == index ? "var(--darkBlue)" : "#ffffff", boxShadow:"0px 0px 8px rgba(0,0,0,0.25)", border:"1px solid var(--darkBlue)"}}>
                                <p className="flex-item" style={{color: currentDropdownIndex == index ? "#ffffff" : "", marginLeft:"0"}}>Follow Up Response</p>
                                <svg className="flex-item m-l-12 svg-stroke" style={{transform: currentDropdownIndex == index ? "rotate(180deg)" : "", transition:"180ms"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L7 7L13 1" stroke={currentDropdownIndex == index ? "#ffffff" : "#4d4d4d"} stroke-width="2" stroke-linecap="round"/>
                                </svg>
                              </div>
                            )
                          } */}

                          {/* RESOLUTION - BUTTON */}
                          {/* {
                            (data.status == "done" || data.rescheduled_followup.length>0) && (
                              <div onClick={()=>toggleCurrentDropdownIndex(index)} className="global-button-container space-between w-full d-flex flex-item" style={{borderRadius:"20px", height:"40px", alignItems:"flex-start", background: currentDropdownIndex == index ? "var(--darkBlue)" : ""}}>
                                <div className="d-flex flex-item w-full" >
                                  <p className="flex-item m-r-12" style={{marginLeft:"0", color: currentDropdownIndex == index ? "#ffffff" : ""}}>Resolution</p>
                                  {
                                    currentDropdownIndex == index ? (
                                      <svg className="flex-item svg-fill" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.85451 4.14662C4.80803 4.10014 4.75285 4.06326 4.69212 4.03811C4.63139 4.01295 4.5663 4 4.50056 4C4.43483 4 4.36974 4.01295 4.309 4.03811C4.24827 4.06326 4.19309 4.10014 4.14661 4.14662C4.10013 4.1931 4.06326 4.24829 4.0381 4.30902C4.01295 4.36976 4 4.43485 4 4.50059C4 4.56633 4.01295 4.63143 4.0381 4.69216C4.06326 4.75289 4.10013 4.80808 4.14661 4.85456L7.64612 8.35229C5.91316 9.53475 4.70663 11.3436 4.28059 13.3979C4.2672 13.4622 4.2666 13.5285 4.27882 13.593C4.29104 13.6575 4.31585 13.7189 4.35183 13.7739C4.38781 13.8288 4.43425 13.8761 4.4885 13.9131C4.54276 13.95 4.60376 13.9759 4.66804 13.9893C4.73231 14.0027 4.79859 14.0033 4.8631 13.9911C4.9276 13.9789 4.98907 13.9541 5.04399 13.9181C5.09891 13.8821 5.1462 13.8357 5.18317 13.7814C5.22014 13.7272 5.24606 13.6662 5.25945 13.6019C5.45084 12.6786 5.82421 11.8028 6.35776 11.0254C6.89131 10.248 7.57435 9.58473 8.36701 9.07423L9.94979 10.6561C9.53728 10.952 9.19408 11.3341 8.944 11.7759C8.69393 12.2178 8.54297 12.7087 8.5016 13.2147C8.46023 13.7207 8.52943 14.2297 8.70442 14.7062C8.8794 15.1828 9.15597 15.6156 9.51494 15.9746C9.87391 16.3336 10.3067 16.6102 10.7832 16.7852C11.2598 16.9602 11.7687 17.0294 12.2747 16.988C12.7806 16.9466 13.2715 16.7957 13.7133 16.5456C14.1551 16.2955 14.5372 15.9523 14.8331 15.5397L19.1455 19.8534C19.2394 19.9473 19.3667 20 19.4994 20C19.6322 20 19.7595 19.9473 19.8534 19.8534C19.9473 19.7595 20 19.6322 20 19.4994C20 19.3666 19.9473 19.2393 19.8534 19.1454L4.85451 4.14662ZM12.1235 10.0032L15.486 13.3659C15.4521 12.4849 15.087 11.6491 14.4636 11.0256C13.8402 10.4022 13.0045 10.037 12.1235 10.0032ZM9.52985 7.41036L10.3327 8.2133C10.877 8.07157 11.4371 7.99999 11.9995 8.00032C15.205 8.00032 18.0556 10.3271 18.7385 13.6019C18.7656 13.7318 18.8432 13.8457 18.9542 13.9185C19.0652 13.9912 19.2005 14.0169 19.3305 13.9898C19.4604 13.9628 19.5743 13.8852 19.647 13.7742C19.7198 13.6632 19.7455 13.5278 19.7184 13.3979C18.9415 9.67318 15.692 7.00039 11.9995 7.00039C11.1446 7.00039 10.3117 7.14338 9.52985 7.41036Z" fill="white"/>
                                      </svg>
                                    ) : (
                                      <svg className="flex-item svg-fill" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.02504 13.602C5.73081 10.327 8.6812 8 12 8C15.3188 8 18.2682 10.327 18.975 13.602C19.003 13.732 19.0832 13.8458 19.1981 13.9186C19.313 13.9914 19.4531 14.0171 19.5876 13.99C19.7221 13.9629 19.8399 13.8854 19.9152 13.7744C19.9905 13.6633 20.0171 13.528 19.9891 13.398C19.185 9.673 15.8217 7 12 7C8.17826 7 4.81496 9.673 4.01087 13.398C3.98288 13.528 4.00945 13.6633 4.08475 13.7744C4.16005 13.8854 4.27791 13.9629 4.4124 13.99C4.54688 14.0171 4.68698 13.9914 4.80188 13.9186C4.91677 13.8458 4.99704 13.732 5.02504 13.602ZM11.9897 10C12.9503 10 13.8715 10.3687 14.5508 11.0251C15.2301 11.6815 15.6117 12.5717 15.6117 13.5C15.6117 14.4283 15.2301 15.3185 14.5508 15.9749C13.8715 16.6313 12.9503 17 11.9897 17C11.029 17 10.1078 16.6313 9.4285 15.9749C8.74924 15.3185 8.36764 14.4283 8.36764 13.5C8.36764 12.5717 8.74924 11.6815 9.4285 11.0251C10.1078 10.3687 11.029 10 11.9897 10Z" fill="#4d4d4d"/>
                                      </svg>
                                    )
                                  }
                                </div>
                              </div>
                            )
                          } */}
                        </div>
                      </div>
                     
                      {/* {
                        (data.rescheduled_followup.length>0) && ( */}
                          <div className="m-t-16 follow-up-response-container" style={{background:"#f5f5f5"}}>
                            <div className="d-flex-wrap">
                              {/* <div className="flex-item" style={{width:"17%", marginRight:"2%"}}>
                                <p className="flex-item fs-12 color-grey-03">Followed-Up On</p>
                                <p className="flex-item font-weight-700">{formatDateAndTime(new Date(data.createdAt))}</p>
                              </div> */}
                               <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-8" : "flex-item"}`} style={{width: window.innerWidth < 641 ? "100%" : "21%", marginRight: window.innerWidth > 640 && "2%"}}>
                                <p className="flex-item color-grey-03 fs-12">Rescheduled Follow Up</p>
                                <p className={`${window.innerWidth < 641 ? "fs-12" : "fs-14"} flex-item font-weight-700`} style={{whiteSpace:"nowrap"}}>{formatDateAndTime(new Date(data.date))}</p>
                              </div>
                              <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-8" : "flex-item"}`} style={{width: window.innerWidth < 641 ? "100%" : "15%", marginRight: window.innerWidth > 640 && "2%"}}>
                                <p className="flex-item color-grey-03 fs-12">Followed-Up by</p>
                                <p className={`${window.innerWidth < 641 ? "fs-12" : "fs-14"} flex-item font-weight-700`}>{data.createdByUser.length>0 && data.createdByUser[0].name}</p>
                              </div>
                              <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-8" : "flex-item"}`} style={{width: window.innerWidth < 641 ? "100%" : "15%", marginRight: window.innerWidth > 640 && "2%"}}>
                                <p className="flex-item color-grey-03 fs-12">Followed-Up Type</p>
                                <p className={`${window.innerWidth < 641 ? "fs-12" : "fs-14"} flex-item font-weight-700`}>{data.scheduled_type}</p>
                              </div>
                              <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-8" : "flex-item"}`} style={{width: window.innerWidth < 641 ? "100%" : "12%", marginRight: window.innerWidth > 640 && "2%"}}>
                                <p className="flex-item color-grey-03 fs-12">Convertibility</p>
                                <p className={`${window.innerWidth < 641 ? "fs-12" : "fs-14"} flex-item font-weight-700`} style={{textTransform:'capitalize'}}>{data.convertibility}</p>
                              </div>
                              <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-8" : "flex-item"}`} style={{width: window.innerWidth < 641 ? "100%" : "15%", marginRight: window.innerWidth > 640 && "2%"}}>
                                <p className="flex-item color-grey-03 fs-12">Call Response</p>
                                <p className={`${window.innerWidth < 641 ? "fs-12" : "fs-14"} flex-item font-weight-700`}>{data.call_response}</p>
                              </div>
                              <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex m-b-8" : "flex-item m-t-16"} `} style={{width: window.innerWidth < 641 ? "100%" : "21%", marginRight: window.innerWidth > 640 && "2%"}}>
                                <p className="flex-item color-grey-03 fs-12">Assigned To</p>
                                <p className={`${window.innerWidth < 641 ? "fs-12" : "fs-14"} flex-item font-weight-700`}>{data.assignedTo.length>0 && data.assignedTo[0].name}</p>
                              </div>
                              <div className={`${window.innerWidth < 641 ? "space-between flex-item d-flex" : "flex-item m-t-16"} `} style={{width: window.innerWidth < 641 ? "100%" : ""}}>
                                <p className="flex-item color-grey-03 fs-12">Call Remarks</p>
                                <p className={`${window.innerWidth < 641 ? "fs-12" : "fs-14"} flex-item font-weight-700`}>{data.call_remark}</p>
                              </div>
                            </div>
                          </div> 
                        {/* )
                      } */}
                    </div>
                  )
                })
              }
              {isLoaderStart && <div className="loader-5 center"><span></span></div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FollowUpHistory;